<template>
  <v-toolbar
    app
    :fixed="toolbar.fixed"
    :clipped-left="toolbar.clippedLeft"
  >
    <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
    <v-toolbar-side-icon v-if="displayToggler"
                         @click.stop="toggleDrawer()"
    ></v-toolbar-side-icon>

    <v-toolbar-title>
      <img :src="require('../assets/fuzzcv-logo.png')"
        height="30"
      >
    </v-toolbar-title>
    <v-toolbar-items>
      <v-btn flat to="/cv" active-class >
         Mes Curriculum Vitae
      </v-btn>
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <MyLogout></MyLogout>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>

import { mapActions, mapState } from 'vuex';

import MyLogout from './MyLogout';
export default {
  components: {
    MyLogout,
  },
  data: () => ({
    toolbar: {
      //
      fixed: true,
      // sets if the toolbar contents is leaving space for drawer (false) or not (true)
      clippedLeft: true
    },
  }),
  computed: {
      ...mapState('sidebar', [
        'open',
        'clipped',
        'fixed',
        'permanent',
        'mini',
      ]),
      displayToggler() {
        /*
        Le bouton de gestion de la sidebar ne doit s'afficher
        que la page d'édition des CV.
        */
        // var urlRegex = new RegExp('/\/cv\/.*\/(\bedit\b|\bcvmodels)');
        // Afficher le toggler uniquement sur les pages d'édition et de sélection du model.
        var urlRegex = /\/cv\/.*\/(\bedit\b|\bcvmodels)/;
        return urlRegex.test(this.$route.path);
      }

    },
    methods : {
      ...mapActions('sidebar', [
        'toggleDrawer',
      ]),
    },

}
</script>
